import { styled } from '@mui/material';
import { ReactComponent as IconCloud } from '../../../assets/images/cloud.svg';

export const StyledIconCloud = styled(IconCloud)(() => ({
  cursor: 'pointer',
  height: '20px',
  width: '20px',
  color: 'currentColor',
}));
